import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthly", "unit", "source"]
  static values = {
    days: { type: Number, default: 30 }
  }

  useMonthly() {
    this.setSource("average_monthly_price")
    if (!this.hasMonthlyTarget || !this.hasUnitTarget) return

    const monthly = Number.parseFloat(this.monthlyTarget.value)
    if (Number.isNaN(monthly) || this.daysValue === 0) return

    this.unitTarget.value = (monthly / this.daysValue).toFixed(2)
  }

  useUnit() {
    this.setSource("unit_price")
    if (!this.hasMonthlyTarget || !this.hasUnitTarget) return

    const unit = Number.parseFloat(this.unitTarget.value)
    if (Number.isNaN(unit)) return

    this.monthlyTarget.value = (unit * this.daysValue).toFixed(2)
  }

  setSource(value) {
    if (!this.hasSourceTarget) return

    this.sourceTarget.value = value
  }
}
